import axiosClient from "./AxiosClient";

export const registerAccount = (account) => {
  return axiosClient.post("/account", account);
};
